import type { i18n } from "i18next";
import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";

export { Trans, useTranslation } from "react-i18next";

/** Wraps an app so `useTranslation()` works. Used by staff web, admin and staff Android. */
export function I18nProvider({ i18n, children }: { i18n: i18n; children: ReactNode }) {
	return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
